<div class="container-fluid px-0">
  <div class="d-flex flex-md-row flex-column align-content-center pb-3">
    <div class="d-lg-flex flex-row gap-4 align-items-center col-6">
      <div class="d-flex gap-2 align-items-center">
        <div class="text-muted col-auto">Filter by</div>
        <ng-select
          *ngIf="showSelect"
          [multiple]="true"
          [items]="statuses"
          groupBy="selectedAllGroup"
          [selectableGroup]="true"
          bindLabel="name"
          bindValue="value"
          placeholder="Status"
          [compareWith]="compareAccounts"
          [(ngModel)]="selectedStatus"
          [closeOnSelect]="false"
          (change)="onSelectionChange()"
          style="max-width: 520px;"
        >
          <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
            <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected" /> Select All
          </ng-template>

          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div class="ng-value" *ngFor="let item of items | slice:0:2">
              <span class="ng-value-label">{{ statusLabelName(item) }}</span>
              <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
            </div>
            <div class="ng-value" *ngIf="items.length > 2">
              <span class="ng-value-label">{{ items.length - 2 }} more...</span>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>

    <div class="d-lg-flex flex-row gap-4 align-items-center col-6 justify-content-end">
      <app-saved-search
        #savedSearch
        [gridApi]="gridApi"
        [viewFilterType]="viewFilterType"
        [module]="module"
        (onClearFilters)="clearFiltersExternally()"
      ></app-saved-search>
    </div>
  </div>

  <div class="row" *ngIf="customerId != null">
    <ag-grid-angular
      style="min-height: 400px; height: 800px;"
      class="ag-theme-alpine w-100"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [gridOptions]="gridOptions"
      [sideBar]="sideBar"
      [paginationPageSize]="paginationPageSize"
      [paginationPageSizeSelector]="paginationPageSizeSelector"
      (paginationChanged)="onPaginationChanged()"
      (dragStopped)="eventHandlingListener($event)"
      (filterChanged)="eventHandlingListener($event)"
      (sortChanged)="eventHandlingListener($event)"
      (columnVisible)="onColumnVisible($event)"
      (gridReady)="onGridReady($event)"
    ></ag-grid-angular>
  </div>
</div>
